import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {FiltersContext} from "../../../context/FiltersContext";
import {getListaKpiApi} from "../../kpi/services/KpiServices";
import DashboardCercaKpiView from "./DashboardCercaKpiView";
import {TranslateContext} from "../../../context/TranslateContext";

export default function DashboardCercaKpiController() {

    const [gri, setGri] = useState('');
    const [items, setItems] = useState([]);
    const [chiaviRicerca, setChiaviRicerca] = useState([]);

    const {updateFiltroKpi} = useContext(FiltersContext);
    const {lingua, loadingNewLang} = useContext(TranslateContext);
    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getListaKpi() {
        let keyRicerca = [];

        let listaKpi = await getListaKpiApi();
        if (listaKpi) {
            listaKpi.data.data.forEach((k) => {
                keyRicerca.push(k.codice);
                keyRicerca.push(k.descrizione);
            });
        }
        setChiaviRicerca(keyRicerca);
    }

    useEffect(() => {
        if (loadingNewLang === false) {
            getListaKpi();
        }
    }, [lingua, loadingNewLang]);

    function onClickCerca() {
        updateFiltroKpi('descrizione', gri);
        history.push('/list-kpi')
    }

    function onChangeAutocomplete(event) {
        setGri(event.target.value);
    }

    function onAutocomplete(event) {
        setItems(chiaviRicerca.filter(cr => cr.includes(event.query)));
    }

    return (
        <DashboardCercaKpiView
            gri={gri}
            items={items}
            onClickCerca={onClickCerca}
            onAutocomplete={onAutocomplete}
            onChangeAutocomplete={onChangeAutocomplete}
            translate={translate}
        />
    );
}